/** @jsxImportSource @emotion/react */
import { fetchBlobUrl } from "../../image-utils";
import Field, { DataSource } from "./Field";

// * "reports/<layer_id>/eye/intake-generated-20261027234932.pdf" -> "intake-generated-20261027234932.pdf"
export const getReportFilename = (blob_name: string | null | undefined): string => {
    if (!blob_name) return "";
    const parts = String(blob_name).split("/");
    return parts[parts.length - 1] || String(blob_name);
};

// * Open the report in a new tab. The blob url needs a fresh SAS token, so it is
// * requested on click instead of once per table row. The tab is opened synchronously
// * (inside the click handler) to avoid popup blockers, then pointed at the signed url.
export const openReport = async (blob_name: string) => {
    const win = window.open("", "_blank");
    try {
        const url = await fetchBlobUrl(blob_name);
        if (win) {
            win.location.href = url;
        } else {
            window.open(url, "_blank");
        }
    } catch (error) {
        win?.close();
        // eslint-disable-next-line no-console
        console.error("Could not open report", error);
    }
};

/**
 * Shows a link to a report (pdf) whose blob name is stored in layer meta.
 * Draft reports are stored as `report_eye_<pdf_report value>_generated`,
 * e.g. set fieldname_getter to `report_eye_intake_generated` to show the draft intake report.
 */
class LayerMetaReportLinkField extends Field {
    field_type = "layer_meta_report_link_field";

    backend_table = "layer_meta";

    set_value(datasource: DataSource): this {
        this.value = null;
        this.value = this.value_filter(datasource.layer?.[this.fieldname_getter], datasource);
        this.config = datasource.config;
        return this;
    }

    formatted_value(value: any = null): string {
        return getReportFilename(value || this.value) || this.string_when_empty;
    }

    display_component(): JSX.Element {
        const blob_name = this.value as string | null;
        if (!blob_name) {
            return <span>-</span>;
        }
        return (
            <a
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    openReport(blob_name);
                }}
            >
                {getReportFilename(blob_name)}
            </a>
        );
    }
}

export default LayerMetaReportLinkField;
